module.exports = __webpack_public_path__ + "img/sausage.c537ee45.svg";